import { FormGroup, FormControl, FormArray, AbstractControl } from '@angular/forms';

function convertFormGroup(control: AbstractControl): any {
    if (control instanceof FormGroup) {
      return Object.keys(control.controls).reduce((acc, key) => {
        acc[key] = convertFormGroup(control.controls[key]);
        return acc;
      }, {} as any);
    } else if (control instanceof FormArray) {
      return control.controls.map((c) => convertFormGroup(c));
    } else if (control instanceof FormControl) {
      const val = control.value;
      if (val === '') return null;
      if (val instanceof Date) return val.toISOString().substring(0, 10);
      return val;
    }
    return null;
  }

export function FormAsType<T>(form: FormGroup): T {
    return convertFormGroup(form) as T;
}